import { ClickAwayListener, Paper, useTheme } from "@material-ui/core";
import React, { CSSProperties, useState } from "react";

export type SectionProps = {
  children: React.ReactChild | React.ReactChild[];
  gap?: number; // the gap between elements inside the section
  elevation?: number;
  elevationOnFocus?: number;
  paddingVertical?: number;
  paddingHorizontal?: number;
  margin?: number;
  variant?: "outlined" | "elevation";
  style?: CSSProperties;
  square?: boolean;
  spacing?: number;
  showIf?: boolean;
};

const Section = (props: SectionProps) => {
  const theme = useTheme();

  const elevation = props.elevation ?? 1;
  const elevationOnFocus = props.elevationOnFocus ?? elevation + 3;
  const variant = props.variant ?? "elevation";
  const square = props.square ?? false;
  const showIf = props.showIf ?? true;
  const spacing = props.spacing ?? 2;
  const paddingVertical = props.paddingVertical ?? spacing;
  const paddingHorizontal = props.paddingHorizontal ?? 2.5;
  const gap = props.gap ?? spacing * 1.5;

  // TODO avoid using flexbox with gap, this does not work on mobile

  const [focus, setFocus] = useState(false);
  const handleClickOn = () => {
    setFocus(true);
  };
  const handleClickAway = () => {
    setFocus(false);
  };

  return (
    <div>
      {showIf && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper
            variant={variant}
            elevation={focus ? elevationOnFocus : elevation}
            onMouseDown={handleClickOn}
            square={square}
            style={{
              backgroundColor: "white",
              paddingTop: theme.spacing(paddingVertical * 1.5),
              paddingBottom: theme.spacing(paddingVertical * 1.5),
              paddingRight: theme.spacing(paddingHorizontal),
              paddingLeft: theme.spacing(paddingHorizontal),
              marginTop: theme.spacing(paddingVertical * 2),
              marginBottom: theme.spacing(paddingVertical * 2),
              ...props.style,
            }}
          >
            <div
              style={{
                display: "grid",
                gridGap: theme.spacing(gap),
              }}
            >
              {props.children}
            </div>
          </Paper>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default Section;
